import { SupportHome } from '@/modules/support/components/home';
import { withMotion } from '../hoc/with-motion';

const AnimatedPage = withMotion(SupportHome);

export const roles: string[] = ['super-admin', 'supporter'];
export const path = '/support';
export const element = <AnimatedPage />